module.exports = __webpack_public_path__ + "static/media/Canvas_508-02.d2a05353.jpg";